import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';

class Deadlines extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">

          <div className="new_banner">
            <div className="banner_content">
              <h1>CSCE 2025</h1>
              <h6>The 2025 World Congress in</h6>
              <h6>Computer Science, Computer Engineering, & Applied Computing (CSCE)</h6>
              <h6>July 21-24, 2025, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          
          <div className="page_content">
            <h4 className="par_header"><b>DEADLINES - EXTENDED:</b></h4>
            <h6 className="par_header"><b>FOR PROSPECTIVE AUTHORS AND SPEAKERS:</b></h6>
            <div className="par">
              Since the books/conference proceedings are planned to be published and indexed in SCIs after the conference (around September 2025), we have some flexibility with the submission deadlines. In response to numerous requests, the paper submission deadline has been extended as detailed below.

              <br /><br />

              <b>EXTENDED DEADLINES:</b>
              <br /> <br />
              We operate on a revolving deadline: papers are reviewed through a Fast-Track Evaluation (FTE) system, meaning that each submission is assigned to referees immediately upon receipt. To help ensure timely feedback, referees receive a modest honorarium pay for their service.

              <br /><br />

              <b>REVOLVING DATE: (but by no later than July 12):</b> <br/> 
              SUBMISSION OF PAPERS (for peer-review evaluation): <br />
              <a target="_blank" href="https://american-cse.org/drafts/">https://american-cse.org/drafts/</a>
              <br/><br />

              <b>REVOLVING DATE:</b> <br/> 
              NOTIFICATION OF ACCEPTANCE/REJECTION <br />
              Will be sent about one week AFTER the date of submission.
              <br/><br />

              <b>REVOLVING DATE:</b> <br/> 
              REGISTRATION: <br />
              <a target="_blank" href="https://american-cse.org/csce2025/registration">https://american-cse.org/csce2025/registration</a><br />
              Authors of accepted papers will find the registration deadline in their notification of acceptance.
              <br/><br />
              Note that failing to register for a conference after having a paper accepted is regarded as a breach of author ethics. Submitting a paper to a conference signifies a commitment to the research community, and neglecting to register undermines this responsibility, potentially disrupting the integrity and collaborative spirit of the academic process.

              <br/><br />

              {/* <b>June 25, 2025:</b> <br/> 
              LOCATION AND ROOM RESERVATION: <br />
              Luxor - an MGM property, Las Vegas, USA <br />
              <a target="_blank" href="https://american-cse.org/csce2025/venue">https://american-cse.org/csce2025/venue</a>
              <br/><br /> */}

              <b>July 21-24, 2025:</b> <br /> 
              <b>The 2025 World Congress in Computer Science, Computer Engineering, and Applied Computing (CSCE'25: USA)</b> <br/>
              Including all affiliated federated/joint conferences <br />              
              <a href="https://www.american-cse.org/csce2025/">https://www.american-cse.org/csce2025/</a> <br />
              <a href="https://american-cse.org/csce2025/conferences" target="_blank" rel="noopener noreferrer">https://american-cse.org/csce2025/conferences</a>
              <br/><br />

              <b>August 30, 2025:</b> <br/> 
              FINAL PAPERS FOR PUBLICATION <br />
              The conference proceedings will be published shortly after the event. The publisher, Springer Nature, will send each author a unique upload link corresponding to their accepted paper. We anticipate that these links will be emailed to authors by approximately August 30, 2025. Once the link is received, authors will have two weeks to upload the final version of their paper for publication. The conference organizers will also send timely reminders to authors to ensure all final submissions are completed within the designated timeframe.

              <br/><br />

              <b>Publisher:</b> <br />
              Springer Nature <br /><br />

              <b>Indexation:</b> <br />
              Scopus; DBLP, EI Engineering Index (Compendex, Inspec databases); Springer Link; Google Scholar; Conference Proceedings Citation Index (CPCI), part of Clarivate Analytics' Web of Science; ACM Digital Library; IO-Port; MathSciNet; Zentralblatt MATH, and others. Last year's CSCE publications can be accessed via: <br />
              <a target="_blank" href="https://link.springer.com/conference/csce-1">https://link.springer.com/conference/csce-1</a>
            
            </div>

            <h6 className="par_header"><b>FOR NON-AUTHORS & NON-SPEAKER ATTENDEES:</b></h6>
            <div className="par">
            <b>July 10, 2025:</b> <br/> 
              REGISTRATION: <br />
              <a target="_blank" href="https://american-cse.org/csce2025/registration">https://american-cse.org/csce2025/registration</a><br />
              <br/><br />
            </div>
            

            

            
            
            
          
          </div>
          

        </div>
      </div>
    );
  }
}

export default Deadlines;